import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import BoxHeader from 'components/BoxHeader';
import Button from 'components/ButtonDeprecated';
import Dialog from 'components/Dialog';
import EventTracking from 'lib/EventTracking';
import Text from 'components/Text';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import { OrganizationType } from 'globalTypes';
import { baseTrackingPrefix } from 'constants/SelfServeConstants';
import React, { useEffect } from 'react';

// @Janet TODO: will be used to add custom events in the next version
// import { pushCustomEvent } from 'lib/googleTagManager';

type Props = {
  organizationName: string;
  organizationType: OrganizationType;
  onClose: () => void;
  onSubmit: () => void;
};

const trackingPrefix = `${baseTrackingPrefix}.upgrade_plan_terms_modal`;

function track(key: string) {
  EventTracking.trackKey(`${trackingPrefix}.${key}`);
}

function handleClose(onClose: () => void) {
  track('close.click');
  onClose();
}

function handleSubmit(onClose: () => void, onSubmit: () => void) {
  track('agree.click');
  // @Janet TODO: will be used to add custom events in the next version
  // pushCustomEvent('self serve purchase')
  onClose();
  onSubmit();
}

export default function AdminUpgradePlanTermsModal(props: Props) {
  const { organizationName, organizationType, onClose, onSubmit } = props;

  useEffect(() => track('view'), []);

  const linkForAgreement =
    organizationType === OrganizationType.District
      ? LinkConstants.DISTRICT_AGREEMENT
      : LinkConstants.SCHOOL_AGREEMENT;

  const onCloseModal = () => handleClose(onClose);
  const onAgree = () => handleSubmit(onClose, onSubmit);

  return (
    <Dialog size="medium" onRequestHide={onCloseModal} hideOnBlur={false}>
      <BoxHeader title={`Remind ${organizationType} Plan Terms`} />
      <BoxBody divided>
        <Text element="p" align="left">
          I am legally authorized to purchase the {organizationType} Plan on behalf of{' '}
          {organizationName}. I understand this order is bound by the terms of the{' '}
          <Link href={linkForAgreement} target="_blank">
            Remind {organizationType} Plan Standard Agreement
          </Link>
          , and I have read Remind’s{' '}
          <Link href={LinkConstants.PRIVACY_POLICY} target="_blank">
            Privacy Policy
          </Link>{' '}
          and{' '}
          <Link href={LinkConstants.TERMS_OF_SERVICE} target="_blank">
            Terms of Service
          </Link>
          .
        </Text>
        <Text element="p" align="left">
          I understand {organizationName} is responsible for complying with the Children’s Online
          Privacy Protection Act of 1998 (COPPA), including obtaining parental consent for
          collection of personal information in Remind.
        </Text>
      </BoxBody>
      <BoxFooter>
        <Button onClick={onAgree}>I agree</Button>
      </BoxFooter>
    </Dialog>
  );
}

export { AdminUpgradePlanTermsModal };
